import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';

import { EditPulseSubtitleComponent } from './EditPulseSubtitle.Component';
import { PulseTimelineComponent } from './PulseTimeline.Component';
import { PulseTimelineEntryComponent } from './PulseTimelineEntry.Component';

@NgModule({
	declarations: [
		PulseTimelineComponent,
		PulseTimelineEntryComponent,
		EditPulseSubtitleComponent
	],
	exports: [
		PulseTimelineComponent
	],
	bootstrap: [
		PulseTimelineComponent
	],

	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		FormsModule,
		PipesAngularModule,
		ScrollingModule,
		TextInputAngularModule,
		TranslateModule,
		ValidationAngularModule,
		VbProfilePictureModule
	]

})
export class PulseModule{}
